import WTF from '@zuul/wtf';
import Schema from './schema';
import template from 'lodash/template';
import tpl from './thankyou.html';

export default class Connect {
    constructor({el}) {
        this.el = el;
        this.schema = new Schema();

        new WTF({ // eslint-disable-line no-new
            el,
            schema: this.schema.data
        });
        
        if (document.body.classList.contains('thank-you')) {
            this.openOverlay();
        }
    }

    bind() {
        const overlay = document.querySelector('.overlay');

        document.querySelector('.overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.open) {
                this.open = false;

                overlay.parentNode.removeChild(overlay);

                this.el.innerHTML = '';

                new WTF({ // eslint-disable-line no-new
                    el: this.el,
                    schema: this.schema.data
                });

                document.body.removeEventListener('keyup');
            }
        });
    }

    openOverlay() {
        const ctpl = template(tpl);
        const node = document.createElement('div');

        node.id = 'thank-you';
        node.classList.add('overlay');
        node.innerHTML = ctpl();

        document.body.appendChild(node);

        this.open = true;
        this.bind();
    }
}
